import Instance from "../../../Axios";

// New Actions for the app

const DeletePlusAdesao = (id) => async (dispatch) => {
  await Instance()
    .put(`/plus/adesoes/delete/${id}`)
    .then(({ data }) => {
      dispatch({ type: "DELETE_PLUS_ADESAO", payload: data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeletePlusAdesao;
